import React, {} from 'react';

import BaseElement from '../base';

function ToggleListItem(props) {

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: 'toggle-list-main'
    };

    return <div {...attributes}>
      {props.children}
    </div>;

  }

  return <BaseElement {...props}>
    {renderMain()}
  </BaseElement>;

}

export default ToggleListItem;
export { default as ToggleListHead } from './head';
export { default as ToggleListBody } from './body';